import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import { initFirebase } from './firebase'

import {
  getFirestore,
  doc,
  getDoc,
} from 'firebase/firestore'

Vue.config.productionTip = false

initFirebase()

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

getEssentials()

async function getEssentials() {
  const ref = doc(getFirestore(), 'data/brands')
  store.commit('setBrands', await (await getDoc(ref)).data())
}